import React from "react";

const Price = ({ scrollToConsult }) => {
  return (
    <section className="p-3 p-lg-0">
      <div className="container border border-1 border-dark rounded-4 mt-5 mb-5">
        <div className="row align-items-center">
          <div className="col-lg-5 p-md-5 py-3 px-2">
            <h2 className="fs-40">What’s It Cost?</h2>
            <p>
              We keep all our pricing as clear and transparent as possible with
              no hidden cost and our flexible payment plans make treatment
              affordable for all.
            </p>
            <p>0% Finance Available On Request</p>
            <div
              className="d-none d-md-block cursor-pointer"
              onClick={scrollToConsult}
            >
              <a className="btn-golden animate__animated animate__slideInRight cursor-pointer">
                BOOK A FREE CONSULTATION
              </a>
            </div>
          </div>
          <div className="col-lg-7 bg-theme rounded-4">
            <div className="row p-md-4 py-4 px-2 border-bottom">
              <div className="col-lg-7">
                <p className="fs-24 text-white fw-500">
                  Invisalign® Clear Braces*
                </p>
              </div>
              <div className="col-lg-5 text-end">
                <p className="fs-24 text-white">
                  <span className="fs-14 me-2">From</span>
                  <span className="fs-18 text-decoration-line-through me-2">
                    £3,749
                  </span>
                  <span className="fs-24">£2,899</span>
                </p>
              </div>
            </div>

            <div className="row p-md-4 py-4 px-2 border-bottom">
              <div className="col-lg-7">
                <p className="fs-24 text-white fw-500">Teeth Whitening</p>
              </div>
              <div className="col-lg-5 text-end">
                <p className="fs-24 text-white">
                  <span className="fs-14 me-2">From</span>
                  <span className="fs-18 text-decoration-line-through me-2">
                    £295
                  </span>
                  <span className="fs-24">Free</span>
                </p>
              </div>
            </div>

            <div className="row p-md-4 py-4 px-2 border-bottom">
              <div className="col-lg-7">
                <p className="fs-24 text-white fw-500">Treatment Simulation</p>
              </div>
              <div className="col-lg-5 text-end">
                <p className="fs-24 text-white">
                  <span className="fs-14 me-2">From</span>
                  <span className="fs-18 text-decoration-line-through me-2">
                    £300
                  </span>
                  <span className="fs-24">Free</span>
                </p>
              </div>
            </div>

            <div className="row p-md-4 py-4 px-2 border-bottom">
              <div className="col-lg-7">
                <p className="fs-24 text-white fw-500">3D Digital Scan</p>
              </div>
              <div className="col-lg-5 text-end">
                <p className="fs-24 text-white">
                  <span className="fs-14 me-2">From</span>
                  <span className="fs-18 text-decoration-line-through me-2">
                    £75
                  </span>
                  <span className="fs-24">Free</span>
                </p>
              </div>
            </div>

            <div className="row p-md-4 py-4 px-2 border-bottom">
              <div className="col-lg-7">
                <p className="fs-24 text-white fw-500">Retainers</p>
              </div>
              <div className="col-lg-5 text-end">
                <p className="fs-24 text-white">
                  <span className="fs-14 me-2">From</span>
                  <span className="fs-18 text-decoration-line-through me-2">
                    £400
                  </span>
                  <span className="fs-24">Free</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <p className="text-center w-md-75 mx-auto nt-5 mb-5 fs-16">
          *Invisalign® pricing is based on the number of aligners needed to
          achieve your dream smile with prices ranging between £1,795 to £4,495.
          Your dentist will be able to determine the number of stages needed at
          your consultation .
        </p>
      </div>
    </section>
  );
};

export default Price;
